/**
 * Created by ChrisMuto on 7/3/17.
 */

export const WEVO_AUDIENCE_DELIMITER = "_";



// WEBPACK FOOTER //
// ./src/modules/audiences/constants.js